import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { LoggingService } from '../services/logging.service';

/**
 * Stamps every outgoing request with the current session id so the
 * server-side request log can correlate rows into a session.
 */
export function sessionInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const sessionId = inject(LoggingService).sessionId;
  return next(request.clone({ setHeaders: { 'X-Session-Id': sessionId } }));
}
